import React from 'react'

const URL_SPLIT_REGEX = /(https?:\/\/[^\s<>"]+)/gi
const URL_TEST_REGEX = /^https?:\/\/[^\s<>"]+$/i

/**
 * Renders text with URLs converted to clickable links that open in a new tab.
 */
const LinkifyText: React.FC<{ text: string }> = ({ text }) => {
  if (!text) return null

  const parts = text.split(URL_SPLIT_REGEX)

  return (
    <>
      {parts.map((part, index) => {
        if (URL_TEST_REGEX.test(part)) {
          return (
            <a
              key={index}
              href={part}
              target="_blank"
              rel="noopener noreferrer"
              className="chat-link"
              onClick={(e) => e.stopPropagation()}
            >
              {part}
            </a>
          )
        }
        return <React.Fragment key={index}>{part}</React.Fragment>
      })}
    </>
  )
}

export default LinkifyText
